module.exports = __webpack_public_path__ + "img/spa.4be55899.svg";